import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input, Button, Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Panel } from 'components/ui/index';
import { setSearchKey, searchAccounts } from '../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);

const propTypes = {
  theme: PropTypes.string.isRequired,
  searchKey: PropTypes.string.isRequired,
  objectName: PropTypes.string.isRequired,
};

class SearchAccount extends React.Component {
  handleSearch = () => {
    const { searchKey, searchAccounts } = this.props;
    searchAccounts(searchKey);
  }

  render() {
    const {
      theme,
      objectName,
      setSearchKey,
      searchKey
    } = this.props;

    return (
      <Panel
        panelClasses={classNames('mt-md', `${theme}-theme-panel`)}
        panelTitle={<FormattedMessage id="page.AttachAccount.searchAccount" />}
      >
        <div className="pt-xlg pb-xlg pl-lg pr-lg">
          <Row gutter={8}>
            <Col span={10} className="text-right">
              <FormattedMessage id="page.AttachAccount.opportunityName">
                {text => <span className={cx('search-content-label')}>{text}:</span>}
              </FormattedMessage>
            </Col>
            <Col span={6}><span className={cx('search-content-name')}>{objectName}</span></Col>
          </Row>
          <Row gutter={8} className="mt-lg">
            <Col span={10} className="text-right">
              <FormattedMessage id="page.AttachAccount.accountName">
                {text => <span className={cx('search-content-label')}>{text}:</span>}
              </FormattedMessage>
            </Col>
            <Col span={6}>
              <Input
                onChange={e => setSearchKey(e.target.value)}
                onPressEnter={this.handleSearch}
                value={searchKey}
                className="full-width"
                placeholder="Phrase Search"
              />
            </Col>
          </Row>
          <Row gutter={8} className="mt-xlg">
            <Col span={11} />
            <Col span={8}>
              <Button className={`${theme}-theme-btn`} onClick={this.handleSearch}>
                <Icon type="search" />
                <FormattedMessage id="page.AttachAccount.search" />
              </Button>
            </Col>
          </Row>
        </div>
      </Panel>
    );
  }
}

SearchAccount.propTypes = propTypes;

const mapStateToProps = ({ clientDetails, global }) => ({
  lang: global.language,
  objectName: clientDetails.attachAccount.objectName,
  searchKey: clientDetails.attachAccount.searchKey
});

const mapDispatchToProps = {
  setSearchKey,
  searchAccounts
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchAccount);



// WEBPACK FOOTER //
// ./src/views/AttachAccount/components/SearchAccount.jsx